import { render, staticRenderFns } from "./DateRangeStatisticsDropdown.vue?vue&type=template&id=8c483a7c&scoped=true&"
import script from "./DateRangeStatisticsDropdown.vue?vue&type=script&lang=js&"
export * from "./DateRangeStatisticsDropdown.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./DateRangeStatisticsDropdown.vue?vue&type=style&index=0&id=8c483a7c&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8c483a7c",
  null
  ,true
)

export default component.exports